import { CoreLocationCountriesMultiselect } from './CoreLocationCountriesMultiselect';
import { CoreLocationLocationTypesMultiselect } from './CoreLocationLocationTypesMultiselect';
import { CoreLocationRegionsMultiselect } from './CoreLocationRegionsMultiselect';
import { CoreLocationsMultiselect } from './CoreLocationsMultiselect';
import { CoreLocationTerritoriesMultiselect } from './CoreLocationTerritoriesMultiselect';

export const CoreLocationMultiselect = {
  Countries: CoreLocationCountriesMultiselect,
  Regions: CoreLocationRegionsMultiselect,
  Locations: CoreLocationsMultiselect,
  LocationTypes: CoreLocationLocationTypesMultiselect,
  Territories: CoreLocationTerritoriesMultiselect,
};
